import { ResultsView } from "./components/resultsView/resultsView";
import { Base } from "./contentResults.base";

export const ContentResults = Object.assign(Base, {
    ResultsView: ResultsView
});
